/**
 * Provider buttons for "Continuar con Google" / "Continuar con Microsoft".
 * Shared by /login and /register.
 */

import { startOAuth } from '@/lib/oauth'

export function OAuthButtons({
  intent = 'login',
  disabled = false,
}: {
  intent?: 'login' | 'register'
  disabled?: boolean
}) {
  return (
    <div className="space-y-2.5">
      <button
        type="button"
        onClick={() => startOAuth('google', intent)}
        disabled={disabled}
        className="flex w-full items-center justify-center gap-2.5 rounded-md border border-border bg-bg-app px-4 py-2.5 text-sm font-medium text-fg-primary transition-colors hover:border-fg-muted hover:bg-bg-elevated disabled:opacity-50"
      >
        <GoogleIcon className="h-4 w-4" />
        Continuar con Google
      </button>
      <button
        type="button"
        onClick={() => startOAuth('microsoft', intent)}
        disabled={disabled}
        className="flex w-full items-center justify-center gap-2.5 rounded-md border border-border bg-bg-app px-4 py-2.5 text-sm font-medium text-fg-primary transition-colors hover:border-fg-muted hover:bg-bg-elevated disabled:opacity-50"
      >
        <MicrosoftIcon className="h-4 w-4" />
        Continuar con Microsoft
      </button>
    </div>
  )
}

export function OAuthDivider({ label = 'o' }: { label?: string }) {
  return (
    <div className="my-5 flex items-center gap-3 text-xs text-fg-muted">
      <span className="h-px flex-1 bg-border" />
      <span className="font-mono uppercase tracking-wider">{label}</span>
      <span className="h-px flex-1 bg-border" />
    </div>
  )
}

// Google "G" official colors — keep brand recognition.
function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  )
}

// Microsoft 4-square logo — official colors.
function MicrosoftIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="13" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="13" width="10" height="10" fill="#00A4EF" />
      <rect x="13" y="13" width="10" height="10" fill="#FFB900" />
    </svg>
  )
}
